import React from 'react';
import { Provider } from 'react-redux';
import { I18nProvider } from '@lingui/react';
import ConfigStore from '../../utils/config';
import { setupI18n } from '../../i18n';
import { init as initFeatures, haveFeaturesBeenInitialized } from '../../featureswitches/Features';
import store from '../../store';
import { Dialog } from '.';
import { setGlassboxLoggerOverride } from '../../glassboxLogger';
const App = ({
  isOpen,
  documentOid,
  onClose,
  onUpgrade,
  page,
  rootNodeId = 'modal-root',
  folderInfo,
  userInfo,
  children,
  prefill,
  showReferralCopyAndCode,
  glassboxLogger,
  evaluatedFeatures
}) => {
  if (!document.getElementById(rootNodeId)) {
    throw new Error(`Failed to render share dialog. You need to have an element with the id of "${rootNodeId}" in your DOM where the share dialog can attach itself.`);
  }
  if (!haveFeaturesBeenInitialized()) {
    initFeatures(evaluatedFeatures);
  }
  React.useEffect(() => {
    if (glassboxLogger !== undefined) {
      setGlassboxLoggerOverride(glassboxLogger);
    }
  }, []);
  const _store = store({
    documentOid,
    page,
    folderInfo,
    userInfo,
    showReferralCopyAndCode
  });
  return React.createElement(Provider, {
    store: _store
  }, React.createElement(I18nProvider, {
    i18n: setupI18n()
  }, React.createElement(ConfigStore, {
    isOpen: isOpen,
    documentOid: documentOid,
    onClose: onClose,
    onUpgrade: feature => onUpgrade(feature, _store.getState().page),
    selectedFolder: folderInfo,
    prefill: prefill,
    modalRootId: rootNodeId
  }, React.createElement(Dialog, {
    modalRootId: rootNodeId,
    initialPage: page
  }, children))));
};
export default App;